import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getCurrentCurrencyData } from '@/helpers/common';
import { amountWithCurrencySymbol, getCurrencyName } from '@/helpers/currency';
import { showTooltip } from '@/helpers/tooltip';
import { useCommonStore } from '@/store';
import { TooltipTypes } from '@/store/tooltipStore';

export const usePaymentNotification = () => {
  const { t } = useTranslation('deposits');

  const playerPayments = useCommonStore.use.playerPayments();
  const currencies = useCommonStore.use.currencies();

  useEffect(() => {
    if (playerPayments.length === 0) return;

    const lastPayment = playerPayments[playerPayments.length - 1];

    if (!lastPayment.success) return;

    const { currency, amount } = getCurrentCurrencyData(
      lastPayment.amountCents,
      lastPayment.currency,
      currencies
    );

    showTooltip({
      type: TooltipTypes.SUCCESS,
      body: t('paymentSuccessful', {
        amount: amountWithCurrencySymbol(getCurrencyName(currency), amount),
      }),
    });
  }, [currencies, playerPayments, t]);
};
